export type ServerInvoicePayment = {
  id: string;
  intent_id: string;
  client_secret: string;
  amount: string;
  currency: string;
  merchant_country_code: string;
};

export type ServerInvoiceRes = {
  invoice_number: string;
  invoice_url: string;
  merchant_name: string;
  payment: ServerInvoicePayment;
  invoice_status: InvoiceStatus;
};

export type InvoiceURLQuery = {
  merchantId: string;
  id: string;
  number: string;
  amountDue: string;
  currency: string;
};

export type SuccessData = {
  payment_id: string;
  amount: string;
  amount_paid: string;
  amount_surcharge_fee: string;
  intent_id: string;
  client_secret: string;
  paid_at: string;
  invoice_number: string;
  status: string;
  merchant_name: string;
  currency: string;
};

export enum InvoiceStatus {
  UNPAID = 'UNPAID',
  PAID = 'PAID',
  INVALID = 'INVALID',
}
